import useFetch from '../../../hooks/useFetch';
import { WarehouseExpeditionDataForm, WarehouseQuoteExpeditionFilters } from '../../models/WareHouseQuoteExpedition';
import { EndPoints } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';

const useWarehouseQuoteExpeditionService = () => {
  const { doGet, doPost, doPut, doDelete } = useFetch();

  const [fetchingGetWarehouseQuoteExpedition, setFetchingGetWarehouseQuoteExpedition] = useState(false);
  const [fetchingUpdateWarehouseQuoteExpedition, setFetchingUpdateWarehouseQuoteExpedition] = useState(false);
  const [fetchingGetWarehouseQuoteExpeditions, setFetchingGetWarehouseQuoteExpeditions] = useState(false);
  const [fetchingStoreWarehouseQuoteExpedition, setFetchingStoreWarehouseQuoteExpedition] = useState(false);
  const [fetchingShowWarehouseQuoteExpedition, setFetchingShowWarehouseQuoteExpedition] = useState(false);
  const [fetchingDeleteWarehouseQuoteExpedition, setFetchingDeleteWarehouseQuoteExpedition] = useState(false);
  const [fetchingEditWarehouseQuoteExpedition, setFetchingEditWarehouseQuoteExpedition] = useState(false);
  const [fetchingCreateWarehouseQuoteExpedition, setFetchingCreateWarehouseQuoteExpedition] = useState(false);

  const getWarehouseQuoteExpedition = (quoteId: number, events: ServiceEvents = {}) => {
    doGet({
      ...events,
      url: EndPoints.WAREHOUSE_QUOTES.GET_WAREHOUSE_EXPEDITION.replace(':quote_id', quoteId.toString()),
      setFetching: setFetchingGetWarehouseQuoteExpedition
    });
  };

  const getAllWarehouseQuoteExpeditionsByQuote = (
        quoteId: number,
        expeditionFilters: WarehouseQuoteExpeditionFilters, 
        events: ServiceEvents = {}
    ) => {
    
    const queryString = Object.entries(expeditionFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
    const url = `${EndPoints.WAREHOUSE_QUOTES.GET_ALL_WAREHOUSE_EXPEDITIONS}?${queryString}`;
    
    doGet({
      ...events,
        url: url.replace(
            ':quote_id',
            quoteId.toString()
        ),
      setFetching: setFetchingGetWarehouseQuoteExpeditions
    });
  };

  const storeWarehouseQuoteExpedition = (data: WarehouseExpeditionDataForm, events: ServiceEvents = {}) => {
    doPost({
      ...events,
      url: EndPoints.WAREHOUSE_QUOTES.STORE_WAREHOUSE_EXPEDITION,
      body: data,
      setFetching: setFetchingStoreWarehouseQuoteExpedition
    });
  };

  const showWarehouseQuoteExpedition = (id: number, events: ServiceEvents = {}) => {
    doGet({
      ...events,
      url: EndPoints.WAREHOUSE_QUOTES.SHOW_WAREHOUSE_EXPEDITION.replace(':id', id.toString()),
      setFetching: setFetchingShowWarehouseQuoteExpedition
    });
  };

  const deleteWarehouseQuoteExpedition = (id: number, events: ServiceEvents = {}) => {
    doDelete({
      ...events,
      url: EndPoints.WAREHOUSE_QUOTES.DELETE_WAREHOUSE_EXPEDITION.replace(':id', id.toString()),
      setFetching: setFetchingDeleteWarehouseQuoteExpedition
    });
  };

  const updateWarehouseQuoteExpedition = (quoteId: number, data: WarehouseExpeditionDataForm, events: ServiceEvents = {}) => {
    doPut({
      ...events,
      url: EndPoints.WAREHOUSE_QUOTES.UPDATE_WAREHOUSE_EXPEDITION.replace(':quote_id', quoteId.toString()),
      body: data,
      setFetching: setFetchingUpdateWarehouseQuoteExpedition
    });
  };

  const createWarehouseQuoteExpedition = (quoteId: number, events: ServiceEvents = {}) => {
    doGet({
      ...events,
      url: EndPoints.WAREHOUSE_QUOTES.CREATE_WAREHOUSE_EXPEDITION.replace(':quote_id', quoteId.toString()),
      setFetching: setFetchingCreateWarehouseQuoteExpedition
    });
  };

  const editWarehouseQuoteExpedition = (quoteId: number, events: ServiceEvents = {}) => {
    doGet({
      ...events,
      url: EndPoints.WAREHOUSE_QUOTES.EDIT_WAREHOUSE_EXPEDITION.replace(':quote_id', quoteId.toString()),
      setFetching: setFetchingEditWarehouseQuoteExpedition
    });
  };

  return {
    getWarehouseQuoteExpedition,
    getAllWarehouseQuoteExpeditionsByQuote,
    storeWarehouseQuoteExpedition,
    showWarehouseQuoteExpedition,
    updateWarehouseQuoteExpedition,
    createWarehouseQuoteExpedition,
    editWarehouseQuoteExpedition,
    deleteWarehouseQuoteExpedition,

    fetchingGetWarehouseQuoteExpedition,
    fetchingUpdateWarehouseQuoteExpedition,
    fetchingGetWarehouseQuoteExpeditions,
    fetchingStoreWarehouseQuoteExpedition,
    fetchingShowWarehouseQuoteExpedition,
    fetchingDeleteWarehouseQuoteExpedition,
    fetchingCreateWarehouseQuoteExpedition,
    fetchingEditWarehouseQuoteExpedition
  };
};

export default useWarehouseQuoteExpeditionService;
